
<template>
  <div
    :class="[isModalOpen ? 'd-flex ': 'd-none']"
    class="size-modal image-modal-wrapper generic-modal position-fixed align-items-center justify-content-center position-fixed "
    style="font-size:16px">
    <div class="modal-inner  align-items-center justify-content-center d-flex h-100 w-100">
      <div class="bm-modal-content bg-white px-24 pt-20  pb-xl-35 pb-lg-29 pb-md-29 position-fixed rounded rounded-4 pt-xl-26 pt-lg-20" >
        <div
          class="p-0 border-0 text-end close-icon-wrapper custom-icon position-absolute"
          @click="handleModalClose">
          <icon name="close-icon"/>
        </div>
        <div class="bm-modal-body border-0 mt-3">
          <h2 class="text-center modal-heading text-dark-gray fs-20 mb-0">Add Custom Size</h2>
          <p
            v-show="!isValidInput.every(Boolean)"
            class="alert alert-danger"
            v-html="getErrorMessage" />
          <div class="main-tabs-content mt-20">
            <form>
              <div class="row">
                <div class="form-group">
                  <label for="size-name">Size Name</label>
                  <input
                    v-model="title"
                    type="text"
                    class="form-control  form-control-lg"
                    placeholder="Enter title for this size">
                </div>

              </div>
              <div class="row mt-20">
                <div class="form-group col">
                  <label for="size-width">Width</label>
                  <input
                    id="size-width"
                    v-model="width"
                    type="number"
                    class="form-control  form-control-lg"
                    placeholder="Width">
                </div>
                <div class="form-group col">
                  <label for="size-height">Height</label>
                  <input
                    id="size-height"
                    v-model="height"
                    type="number"
                    class="form-control  form-control-lg"
                    placeholder="Height">
                </div>
                <div class="form-group col">
                  <label for="size-unit" >Unit</label>
                  <select
                    id="size-unit"
                    v-model="unit"
                    class="form-control form-control-lg"
                    name="size-unit"
                    style="appearance: auto; background: white">
                    <option value="Pixels">Pixels</option>
                    <option value="Inches">Inches</option>
                  </select>
                </div>

              </div>
            </form>
          </div>
        </div>

        <div
          class="bm-modal-footer mt-xl-30 mt-lg-24  mt-md-24 d-flex justify-content-between align-items-center">

          <button
            class="lf-btn blue-border-btn action-btn bg-white"
            @click="handleModalClose">Cancel</button>
          <button
            class="bm-primary-btn action-btn"
            @click.stop="addFavouriteSize">Save</button>
        </div>
      </div>
    </div>
    <div
      class="backdrop position-fixed h-100 w-100"
      @click="handleModalClose"
    />
  </div>
</template>
<script>
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

export default {
  data() {
    return {
      isModalOpen:  false,
      width:        0,
      height:       0,
      unit:         'px',
      title:        'custom-size',
      message:      ['Height should be a greater than 0.14 inch/ 10 pixels and less than 100 inches / 7200px ', 'Width should be a greater than 0.14 inch/ 10 pixels and less than 100 inches / 7200px', 'Length of title must be greater than 3 and less than 20'],
      isValidInput: [true, true, true],
    };
  },
  computed: {
    getErrorMessage() {
      let toReturn = '';
      this.message.forEach((item, index) => {
        if (!this.isValidInput[index]) { toReturn += `${item}<br>`; }
      });
      return toReturn;
    },
  },
  mounted() {
    EventBus.$on(ApplicationEventTypes.ModalEvents.SHOW_SIZE_MODAL, this.showModal);
  },


  methods: {

    handleModalClose() {
      this.$store.commit('setSizeModel', false);
      this.isModalOpen = !this.isModalOpen;
    },
    showModal(temData) {
      this.isModalOpen = true;
      this.width       = temData.width;
      this.height      = temData.height;
      this.unit        = temData.unit;
      /*
      this.modelData.request           = temData.request;
      this.modelData.message           = temData.message;
      this.modelData.data              = temData.data; */
    },
    validateInput() {
      const isWidthNumeric  = /^-?[0-9]+(?:\.[0-9]+)?$/.test(this.width) && ((this.unit == 'Inches' && this.width >= 0.14 && this.width <= 100) || (this.unit == 'Pixels' && this.width >= 10 && this.width <= 7200));
      const isHeightNumeric = /^-?[0-9]+(?:\.[0-9]+)?$/.test(this.height) && ((this.unit == 'Inches' && this.height >= 0.14 && this.height <= 100) || (this.unit == 'Pixels' && this.height >= 10 && this.height <= 7200));
      const isTitleValid    = this.title.length > 3 && this.title.length < 20;
      return {
        isValid:       isHeightNumeric && isWidthNumeric && isTitleValid,
        messageToShow: [isHeightNumeric, isWidthNumeric, isTitleValid],
      };
    },
    addFavouriteSize() {
      const validationResult = this.validateInput();
      this.isValidInput      = [true, true, true];
      if (!validationResult.isValid) {
        this.isValidInput =  validationResult.messageToShow;
        return;
      }
      const userId    = this.$store.getters.getUserId;
      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url       = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=AddUserFavoriteSize&domainURL=https://${domainUrl}.com/&userId=${userId}&name=${this.title}&width=${this.width}&height=${this.height}&unit=${this.unit}`;

      const oReq = new XMLHttpRequest();
      oReq.addEventListener('load', (Response) => {
        const parser            = new DOMParser();
        const xmlParsed         = parser.parseFromString(Response.target.response, 'text/xml');
        let favouriteSizeResult = xmlParsed.getElementsByTagName('AddUserFavoriteSizeResult');
        favouriteSizeResult[0] && (favouriteSizeResult = favouriteSizeResult[0].innerHTML);
        const parse = JSON.parse(favouriteSizeResult);
        this.$store.commit('updateFavouriteSizes', parse);
        alert('size added successfully');
        this.isModalOpen = false;
      });
      oReq.addEventListener('error', (e) => {
        console.error(e);
        alert('size add failed');
        this.isModalOpen = false;
      });
      oReq.open('GET', url);
      oReq.send();
    },
  },
};

</script>
<style  lang="scss">
  .generic-modal{
    .bm-modal-content{
      max-height: none !important;
      height: auto;
      width: 34vw !important;
      min-width: 0;

      .bm-modal-footer{
        max-width: 250px;
      }
    }
    .close-icon-wrapper{
      top: 10px;
      right: 10px;
    }
  }

  @media screen and (max-width: 1285px){
  .bm-modal-content  .fs-20{
      font-size: 18px !important;
    }

  }
  .div-wrapper{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: -5px !important;
  }
  .input-field{
    font-size: 16px;
    width: 80px;
    height: 37px;
    margin-right: 10px;
    text-align: center;
    border: 1px solid #ededed;
  }
  .input-name-field{
    font-size: 16px;
    width: 180px;
    height: 35px;
    margin-left: 10px;
    text-align: center;
    border: 1px solid #ededed;
  }
</style>
